import "./style.css";

function Input({ RightIcon, LeftIcon, className = "", required = false, ...rest }) {
  return (
    <div id="custom-input-v2">
      <input className={`form-control ${className}`} {...rest} />

      {
        RightIcon && <div className="civ2-ir">{RightIcon}</div>
      }
      {
        LeftIcon && <div className="civ2-il">{LeftIcon}</div>
      }
      {
        required && <span className="req-tag">*</span>
      }

    </div>
  )
}
export default Input;
